import React from "react";
import logo from "../../../../assets/Images/Parsecc Logo.png";
import "./ParseccLogo.css";

const ParseccLogo = () => {
  return <img className='logoStylemap' alt='' src={logo} />;
};

export default ParseccLogo;
